export default __webpack_public_path__ + "static/media/laptop.d441d9f0.svg";